import { memo } from "react";
import TrendUpIcon from "../icons/TrendUpIcon";
import UserFollowIcon from "../icons/UserFollowIcon";
import BgFollow from "../icons/bg-follow.png";
import BgVideo from "../icons/bg-video.png";
import VideoIcon from "../icons/VideoIcon";
import PlusIcon from "../icons/PlusIcon";
import { _t } from "core/language";
import { useGoToCreate } from "./../hooks";

interface SelectCategoryCommunityProps {
  onSelect: any;
  active?: any;
}

const SelectCategoryCommunity = ({ onSelect, active }: SelectCategoryCommunityProps) => {
  const goToCreate = useGoToCreate();

  return (
    <div className="px-4 py-[10px] mt-[42px] fixed w-full z-[200] bg-[#EEEEEE]">
      <div className="grid grid-cols-4 gap-2 ">
        <div
          className={`flex flex-col items-center justify-center rounded-lg bg-cover bg-center h-[60px] ${active === "trending" ? "bg-[#FF6741]" : ""}`}
          style={{ backgroundImage: `${active !== 'trending' ? `url(${BgVideo})` : 'none'}` }}
          onClick={() => onSelect("trending")}
        >
          <TrendUpIcon />
          <span className="text-xs text-white text-center mt-[2px]">{_t("main.community.trending")}</span>
        </div>
        <div
          className={`flex flex-col items-center justify-center rounded-lg bg-cover bg-center h-[60px] ${active === "follow" ? "bg-[#FF6741]" : ""}`}
          style={{ backgroundImage: `${active !== 'follow' ? `url(${BgFollow})` : 'none'}`}}          
          onClick={() => onSelect("follow")}
        >
          <UserFollowIcon />
          <span className="text-xs text-white text-center mt-1">{_t("main.community.follow")}</span>
        </div>
        <div
          className={`flex flex-col items-center justify-center rounded-lg bg-cover bg-center h-[60px] ${active === "video" ? "bg-[#FF6741]" : ""}`}
          style={{ backgroundImage: `${active !== 'video' ? `url(${BgVideo})` : 'none'}`}}
          onClick={() => onSelect("video")}
        >
          <VideoIcon />
          <span className="text-xs text-white text-center mt-1">{_t("main.community.video")}</span>
        </div>
        <div
          className="flex flex-col items-center justify-center bg-white rounded-lg"
          onClick={() => goToCreate()}
        >
          <PlusIcon />
        </div>
      </div>
    </div>
  );
};

export default memo(SelectCategoryCommunity);
